<template>
  <div>
    <Checkbox
      class="cb-card mt-10 heading-4 weight-medium"
      title='Other Source of Income'
      v-model="income.otherIncome"
      :checked="income.otherIncome"
    >
      <p class="body-3 weight-regular pt-5">
        Physical person registered at the Office of Labour, receiving a pension, a student, etc.
      </p>

      <div class="input-box-holder" v-validate="errors" v-has-value="income.otherIncome">
        <div class="validation-output text-left mt-10">
          <ErrorHandler class="error" :id="`V151_${index}`">
            You have not selected any of the options. To continue, please select one option.
          </ErrorHandler>
        </div>

        <!-- Stara sa o dieta -->
        <div v-if="income.otherIncome">
          <Checkbox
            v-model.trim="lifeSituation.careForChild"
            class="input-box weight-medium body-2 bt-gray-300 mt-10 pt-10"
            title='Caregiver for a Child'
          >
            <div v-if="lifeSituation.careForChild">
              <div class="input-box-holder" v-validate="errors" v-has-value="lifeSituation.careForCholdType">
                <div class="validation-output text-left mt-10">
                  <ErrorHandler class="error" :id="`V061_${index}`">
                    You have not selected any of the options. To continue, please select one option.
                  </ErrorHandler>
                </div>
                <RadioButton v-for="(option) in enumsValues.CareForChildEnum"
                  class="input-box mt-10 weight-regular body-3"
                  :key="option.name$"
                  :title="option.label"
                  :option="option"
                  :name="'careForChild' + index"
                  v-model="lifeSituation.careForChildType"
                />
              </div>
            </div>
          </Checkbox>

          <!-- Studuje -->
          <Checkbox
            v-model.trim="lifeSituation.student"
            class="input-box weight-medium body-2 bt-gray-300 mt-10 pt-10"
            title='Student'
          >
            <div v-if="lifeSituation.student">
              <div class="input-box-holder" v-validate="errors" v-has-value="lifeSituation.studentType">
                <div class="validation-output text-left mt-10">
                  <ErrorHandler class="error" :id="`V058_${index}`">
                    You have not selected any of the options. To continue, please select one option.
                  </ErrorHandler>
                </div>
                <RadioButton v-for="(option) in enumsValues.StudentEnum"
                  class="input-box mt-10 weight-regular body-3"
                  :key="option.name$"
                  :title="option.label"
                  :option="option"
                  :name="'student' + index"
                  v-model="lifeSituation.studentType"
                />
              </div>
            </div>
          </Checkbox>

          <!-- Opratruje osobu -->
          <Checkbox
            v-model.trim="lifeSituation.takesCare"
            class="input-box weight-medium body-2 bt-gray-300 mt-10 pt-10"
            title='Caregiver for Another Person'
          >
            <div v-if="lifeSituation.takesCare">
              <div class="input-box-holder" v-validate="errors" v-has-value="lifeSituation.takesCareType">
                <div class="validation-output text-left mt-10">
                  <ErrorHandler class="error" :id="`V069_${index}`">
                    You have not selected any of the options. To continue, please select one option.
                  </ErrorHandler>
                </div>
                <RadioButton v-for="(option) in enumsValues.TakesCareEnum"
                  class="input-box mt-10 weight-regular body-3"
                  :key="option.name$"
                  :title="option.label"
                  :option="option"
                  :name="'takesCare' + index"
                  v-model="lifeSituation.takesCareType"
                />
              </div>
            </div>
          </Checkbox>

          <!-- Pobera dochodok -->
          <Checkbox
            v-model.trim="lifeSituation.retirement"
            class="input-box weight-medium body-2 bt-gray-300 mt-10 pt-10"
            title='Receiving a Pension'
          >
            <div v-if="lifeSituation.retirement">
              <div class="input-box-holder" v-validate="errors" v-has-value="lifeSituation.retirement">
                <div class="validation-output text-left mt-10">
                  <ErrorHandler class="error" :id="`V052_${index}`">
                    You have not selected any of the options. To continue, please select one option.
                  </ErrorHandler>
                </div>
                <Checkbox
                  v-model="lifeSituation.oldAgeRetirement"
                  class="mt-10"
                  title='Old Age'
                />
                <Checkbox
                  v-model="lifeSituation.retiredRetirement"
                  class="mt-10"
                  title='Retirement'
                />
                <Checkbox
                  v-model="lifeSituation.invalidRetirement"
                  class="mt-10"
                  title='Disability'
                />
              </div>
            </div>
          </Checkbox>

          <!-- Nevznikol narok na dochodok -->
          <Checkbox
            v-model.trim="lifeSituation.noRetirementClaim"
            class="input-box weight-medium body-2 bt-gray-300 mt-10 pt-10"
            title='No Entitlement to a Pension'
          >
            <div v-if="lifeSituation.noRetirementClaim">
              <div class="input-box-holder" v-validate="errors" v-has-value="lifeSituation.noRetirementClaimType">
                <div class="validation-output text-left mt-10">
                  <ErrorHandler class="error" :id="`V074_${index}`">
                    You have not selected any of the options. To continue, please select one option.
                  </ErrorHandler>
                </div>
                <RadioButton v-for="(option) in enumsValues.NoRetirementClaimEnum"
                  class="input-box mt-10 weight-regular body-3"
                  :key="option.name$"
                  :title="option.label"
                  :option="option"
                  :name="'noRetirementClaim' + index"
                  v-model="lifeSituation.noRetirementClaimType"
                />
              </div>
            </div>
          </Checkbox>

          <!-- Je dlhodobo PN / OCR -->
          <Checkbox
            v-model.trim="lifeSituation.longTerm"
            class="input-box weight-medium body-2 bt-gray-300 mt-10 pt-10"
            title='Long-term Incapacity for Work (PN) / Caregiver for a Family Member (OČR)'
          >
            <div v-if="lifeSituation.longTerm">
              <div class="input-box-holder" v-validate="errors" v-has-value="lifeSituation.longTermType">
                <div class="validation-output text-left mt-10">
                  <ErrorHandler class="error" :id="`V065_${index}`">
                    You have not selected any of the options. To continue, please select one option.
                  </ErrorHandler>
                </div>
                <RadioButton v-for="(option) in enumsValues.LongTermEnum"
                  class="input-box mt-10 weight-regular body-3"
                  :key="option.name$"
                  :title="option.label"
                  :option="option"
                  :name="'longTerm' + index"
                  v-model="lifeSituation.longTermType"
                />
              </div>
            </div>
          </Checkbox>

          <!-- Ine -->
          <Checkbox
            v-model.trim="lifeSituation.other"
            class="input-box weight-medium body-2 bt-gray-300 bb-gray-300 mt-10 py-10"
            title='Other'
          >
            <div v-if="lifeSituation.other">
              <div class="input-box-holder" v-validate="errors" v-has-value="lifeSituation.other">
                <div class="validation-output text-left mt-10">
                  <ErrorHandler class="error" :id="`V217_${index}`">
                    You have not selected any of the options. To continue, please select one option.
                  </ErrorHandler>
                </div>
                <Checkbox
                  v-model="lifeSituation.receiveAContributionInMaterialNeed"
                  class="mt-10"
                  title='receiving Material Hardship Benefits'
                />
                <Checkbox
                  v-model="lifeSituation.worksForChurchOrCharity"
                  class="mt-10"
                  title='work for a Church or Charity'
                />
                <Checkbox
                  v-model="lifeSituation.isInInstitutionalCare"
                  class="mt-10"
                  title='receiving Institutional Health Services'
                />
                <Checkbox
                  v-model="lifeSituation.isPersonalAssistantForZTP"
                  class="mt-10"
                  title='personal Assistant for a Person with Disability (ZŤP)'
                />
              </div>
            </div>
          </Checkbox>
        </div>
      </div>
    </Checkbox>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import RadioButton from '@/components/RadioButton/RadioButton.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';
import enums from '@/mixins/enums';

export default {
  name: 'OtherPackage',
  mixins: [enums],
  components: { RadioButton, Checkbox, ErrorHandler },
  props: {
    lifeSituation: { type: Object, required: true },
    income: { type: Object, required: true },
    errors: { type: Array, required: true },
    index: { type: Number, required: true },
  },
};
</script>
